import { ArrowDown, Loader2 } from "lucide-react";

export const LoadMoreButton = ({ hasMore, loading, onClick, lang = "en", testid = "load-more-btn" }) => {
  if (!hasMore) return null;
  const label = loading
    ? (lang === "fr" ? "Chargement…" : "Loading…")
    : (lang === "fr" ? "Voir plus" : "Load more");
  return (
    <div className="flex justify-center mt-10">
      <button
        type="button"
        data-testid={testid}
        onClick={onClick}
        disabled={loading}
        className="group inline-flex items-center gap-2 rounded-full border-2 border-[#111827] px-7 min-h-[48px] text-sm font-semibold text-[#111827] bg-white hover:bg-[#111827] hover:text-white disabled:opacity-60 transition-colors duration-200"
      >
        {label}
        {loading
          ? <Loader2 size={16} className="animate-spin" />
          : <ArrowDown size={16} className="transition-transform duration-200 group-hover:translate-y-0.5" />}
      </button>
    </div>
  );
};

export default LoadMoreButton;
